import { render, staticRenderFns } from "./PagamentosItens.vue?vue&type=template&id=d98359d0&scoped=true&"
import script from "./PagamentosItens.vue?vue&type=script&lang=js&"
export * from "./PagamentosItens.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosItens.vue?vue&type=style&index=0&id=d98359d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98359d0",
  null
  
)

export default component.exports